export default __webpack_public_path__ + "static/cafe_36017-4d7c444e773f5d4f039a191f926096c2.png";